import { getContext } from 'svelte';

const creditCardContext = () => getContext('creditCardContext');

export { creditCardContext };
